export type Application = {
  id?: string;
  updated_at?: string;
  user_id?: string;
  season_id?: string;
  team_id?: string | null;
  role: "member" | "captain";
  status: string;
  rejection_reason?: string;
  additional_team_request?: boolean;
  data: Record<string, unknown>;
};
export type Captain = {
  team_id: string;
  team_name: string;
  captain_name: string;
  avatar_url?: string;
};
export type Team = {
  request_id?: string | null;
  team_id?: string;
  team_name: string;
  role: string;
  status: string;
  description?: string;
  rejection_reason?: string;
};
export const liftTracks = [
  "Weights",
  "Cardio",
  "Calisthenics",
  "CrossFit",
  "Sports",
];
export const learnTracks = [
  "Tfillian",
  "Kosher",
  "Shabbat",
  "Daily Minyans",
  "Mussar",
  "Rabbi Shua’s class",
  "Parsha",
  "Book Club",
  "DAF Yomi / Talmud",
  "Philosophy",
  "Independent",
];
export function text(a: Application, key: string) {
  return String(a.data[key] ?? "");
}
export function tracks(a: Application, key: string): string[] {
  return Array.isArray(a.data[key]) ? (a.data[key] as string[]) : [];
}
/** Internal phone-auth aliases must never be suggested as participant names. */
function isGeneratedName(name: unknown): boolean {
  return typeof name === "string" &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}@firebase\.lift-and-learn\.invalid$/i.test(name.trim());
}
export function recoverGeneratedDraftName(application: Application): Application {
  if (application.status !== "draft" || !isGeneratedName(application.data.name)) return application;
  // Recover abandoned pre-fix drafts, while leaving submitted names untouched.
  return { ...application, data: { ...application.data, name: "", step: 0 } };
}
export function freshApplication(
  profile: Record<string, unknown>,
  phone?: string,
): Application {
  return {
    role: "member",
    status: "draft",
    data: {
      name: isGeneratedName(profile.display_name) ? "" : profile.display_name ?? "",
      avatar_url: profile.avatar_url ?? "",
      phone: phone ?? profile.phone ?? "",
      tier: "Varsity",
      lift_tracks: [],
      learn_tracks: [],
    },
  };
}
export function toggleTrack(current: string[], track: string) {
  return current.includes(track)
    ? current.filter((t) => t !== track)
    : current.length < 3
      ? [...current, track]
      : current;
}
export function nextStep(step: number, role: string) {
  return step === 2 && role === "captain" ? 4 : Math.min(step + 1, 9);
}
export function validStep(a: Application, step: number) {
  return step === 0
    ? !!text(a, "name").trim()
    : step === 2
      ? a.role === "captain"
        ? !!text(a, "team_name").trim()
        : !!a.team_id
      : step === 5
        ? tracks(a, "lift_tracks").length > 0 &&
          tracks(a, "learn_tracks").length > 0
        : true;
}
